<template>
	<button v-bind:click="handleClick()" :type="isSubmit? 'submit': 'button'" :class="buttonClassName">
		<slot></slot>
		<div class="load-button-loader loading-dots flex-row align-items-center justify-content-center">
			<div class="dot"></div>
			<div class="dot"></div>
			<div class="dot"></div>
		</div>
	</button>
</template>

<script>
export default {
	props:{
		buttonClass: String,
		click: Function,
		isLoading: Boolean,
		isSubmit: Boolean,
	},
	computed: {
		buttonClassName: function(){
			return `load-button ${this.buttonClass} ${this.isLoading? 'is-loading': ''}`;
		},
	},
	methods:{
		handleClick: function(){
			if (this.click) this.click()
		}
	}
}
</script>

<style scoped>
.load-button{position:relative;}
.load-button-loader{position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(55,71,79,0.7);display:none;}
.load-button.is-loading .load-button-loader{display:flex;}
.load-button-loader .dot{margin:0 2px;}
.isLoading{}
</style>


// WEBPACK FOOTER //
// src/components/form/load-button.vue